export const PROFILE_PAGE_KEY = '@@profilePage';

export const ActionTypes = {
    CHANGE_INSURANCE: `${PROFILE_PAGE_KEY}/CHANGE_INSURANCE`,
    CHANGE_PROCEDURE: `${PROFILE_PAGE_KEY}/CHANGE_PROCEDURE`,
    CLICK_JOIN: `${PROFILE_PAGE_KEY}/CLICK_JOIN`,
    CLICK_NAVIGATION_TABS: `${PROFILE_PAGE_KEY}/TRACK_NAVIGATION_TABS`,
    CLICK_REVIEW_LINK: `${PROFILE_PAGE_KEY}/CLICK_REVIEW_LINK`,
    CLICK_REVIEW_STARS: `${PROFILE_PAGE_KEY}/CLICK_REVIEW_STARS`,
    CLICK_SEO_BREADCRUMB: `${PROFILE_PAGE_KEY}/CLICK_SEO_BREADCRUMB`,
    CLICK_SERVICE_EMAIL: `${PROFILE_PAGE_KEY}/CLICK_SERVICE_EMAIL`,
    CLICK_SERVICE_PHONE: `${PROFILE_PAGE_KEY}/CLICK_SERVICE_PHONE`,
    CLICK_SIGN_IN: `${PROFILE_PAGE_KEY}/CLICK_SIGN_IN`,
    DELETE_PREVIEW_PROVIDER_FAILURE: `${PROFILE_PAGE_KEY}/DELETE_PREVIEW_PROVIDER_FAILURE`,
    DELETE_PREVIEW_PROVIDER_SUCCESS: `${PROFILE_PAGE_KEY}/DELETE_PREVIEW_PROVIDER_SUCCESS`,
    DELETING_PREVIEW_PROVIDER: `${PROFILE_PAGE_KEY}/DELETING_PREVIEW_PROVIDER`,
    HIDE_MAP: `${PROFILE_PAGE_KEY}/HIDE_MAP`,
    INITIALIZE: `${PROFILE_PAGE_KEY}/INITIALIZE`,
    SHOW_MAP: `${PROFILE_PAGE_KEY}/SHOW_MAP`,
    TRACK_CLICK_I_BUBBLE_OFFICE_LOCATIONS: `${PROFILE_PAGE_KEY}/TRACK_CLICK_I_BUBBLE_OFFICE_LOCATIONS`,
    TRACK_DISPLAY_HEADER_TITLE_TOOLTIP: `${PROFILE_PAGE_KEY}/TRACK_DISPLAY_HEADER_TITLE_TOOLTIP`,
    TRACK_MOBILE_HEADER_VIEW_MAP: `${PROFILE_PAGE_KEY}/TRACK_MOBILE_HEADER_VIEW_MAP`,
    TRACK_NEW_EXISTING_TOGGLE_VIEW: `${PROFILE_PAGE_KEY}/TRACK_NEW_EXISTING_TOGGLE_VIEW`,
    TRACK_PAGE_FOOTER_LINK_CLICK: `${PROFILE_PAGE_KEY}/TRACK_PAGE_FOOTER_LINK_CLICK`,
    TRACK_PAGEHEADER_CTALINK_CLICK: `${PROFILE_PAGE_KEY}/TRACK_PAGEHEADER_CTALINK_CLICK`,
    TRACK_PAGEHEADER_LOGO_CLICK: `${PROFILE_PAGE_KEY}/TRACK_PAGEHEADER_LOGO_CLICK`,
    TURN_BOOKING_SPOTLIGHT_OFF: `${PROFILE_PAGE_KEY}/TURN_BOOKING_SPOTLIGHT_OFF`,
    TURN_BOOKING_SPOTLIGHT_ON: `${PROFILE_PAGE_KEY}/TURN_BOOKING_SPOTLIGHT_ON`,
    UPDATE_USER: `${PROFILE_PAGE_KEY}/UPDATE_USER`,
};
